export default "__VITE_ASSET__561c0cd7__"